<script setup lang="ts">
import { computed } from "vue"
import { storeToRefs } from "pinia"
import { useUserSettingsStore } from "@/store/user-settings.store"
import logo from "@/assets/img/logo-peanuts.svg"
import whiteLogo from "@/assets/img/logo-peanuts-white.svg"
import verticalLogo from "@/assets/img/logo-peanuts-vertical.svg"
import whiteVerticalLogo from "@/assets/img/logo-peanuts-vertical-white.svg"

const props = withDefaults(defineProps<{ vertical?: boolean }>(), { vertical: false })
const { isDarkMode } = storeToRefs(useUserSettingsStore())
const source = computed(() => {
  if (props.vertical) return isDarkMode.value ? whiteVerticalLogo : verticalLogo
  return isDarkMode.value ? whiteLogo : logo
})
</script>

<template>
  <img :src="source" alt="Peanuts" />
</template>
